module.exports = __webpack_public_path__ + "img/accessory_shirt_02.a8071db8.svg";